export default __webpack_public_path__ + "static/media/workshop.9b39cfbc.png";